import {
	Checkbox,
	Col,
	Form,
	Input,
	Row,
	Typography,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
const { Text } = Typography;

const ProductionWeeklyView = ({ productionId }) => {
	const [form] = Form.useForm();
	const [loadingButton, setLoadingButton] = useState(true);
	const [initialValues, setInitialValues] = useState({});
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getProduction();
	}, []);

	const getProduction = async () => {
		try {
			setLoadingButton(true);

			const url = api + `/production-new/eticket/${productionId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;
				setInitialValues({
					mainPowerOK: payload.mainPower,
					mainPowerNOK: !payload.mainPower,
					mainPowerComment: payload.mainPowerComment,
					controllerFunctionalOK: payload.controllerFunctional,
					controllerFunctionalNOK: !payload.controllerFunctional,
					controllerFunctionalComment: payload.controllerFunctionalComment,
					cpuFunctionalOK: payload.cpuFunctional,
					cpuFunctionalNOK: !payload.cpuFunctional,
					cpuFunctionalComment: payload.cpuFunctionalComment,
					waterValvesOK: payload.waterValves,
					waterValvesNOK: !payload.waterValves,
					waterValvesComment: payload.waterValvesComment,
					airLeaksOK: payload.airLeaks,
					airLeaksNOK: !payload.airLeaks,
					airLeaksComment: payload.airLeaksComment,
					materialGatesOK: payload.materialGates,
					materialGatesNOK: !payload.materialGates,
					materialGatesComment: payload.materialGatesComment,
					oilCompressorOK: payload.oilCompressor,
					oilCompressorNOK: !payload.oilCompressor,
					oilCompressorComment: payload.oilCompressorComment,
					airCompressorPressureOK: payload.airCompressorPressure,
					airCompressorPressureNOK: !payload.airCompressorPressure,
					airCompressorPressureComment: payload.airCompressorPressureComment,
					plantDispensesOK: payload.plantDispenses,
					plantDispensesNOK: !payload.plantDispenses,
					plantDispensesComment: payload.plantDispensesComment,
					bandRotatesOK: payload.bandRotates,
					bandRotatesNOK: !payload.bandRotates,
					bandRotatesComment: payload.bandRotatesComment,
					chemicalLevelOK: payload.chemicalLevel,
					chemicalLevelNOK: !payload.chemicalLevel,
					chemicalLevelComment: payload.chemicalLevelComment,
					reviewVibratorsOK: payload.reviewVibrators,
					reviewVibratorsNOK: !payload.reviewVibrators,
					reviewVibratorsComment: payload.reviewVibratorsComment,
					cementGateOK: payload.cementGate,
					cementGateNOK: !payload.cementGate,
					cementGateComment: payload.cementGateComment,
					humidityProcessOK: payload.humidityProcess,
					humidityProcessNOK: !payload.humidityProcess,
					humidityProcessPercentage: payload.humidityProcessPercentage,
				});
				setLoadingButton(false);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to get production",
			);
			console.error(err.message);
			return null;
		}
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16} style={{ paddingBottom: 20, paddingTop: 20 }}>
					<Col span={24}>
						<Row gutter={16} justify={"space-between"}>
							<Col span={8}>
								<Text strong>Description / Additional Description</Text>
							</Col>
							<Col span={8}>
								<Text strong>Comments</Text>
							</Col>
							<Col>
								<Row gutter={16} justify={"end"}>
									<Col>
										<Text strong>OK</Text>
									</Col>
									<Col>
										<Text strong>NOK</Text>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row gutter={16}>
					<ItemChecked
						ok={"mainPowerOK"}
						nok={"mainPowerNOK"}
						text={"mainPowerComment"}
						title={"Main power is on and in good condition."}
						description={"If it is off, it must be turned on."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"controllerFunctionalOK"}
						nok={"controllerFunctionalNOK"}
						text={"controllerFunctionalComment"}
						title={"The controller is on and functioning properly."}
						description={"If it is off, it must be turned on."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"cpuFunctionalOK"}
						nok={"cpuFunctionalNOK"}
						text={"cpuFunctionalComment"}
						title={"The CPU is on and functioning properly."}
						description={"If it is off, it must be turned on."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"waterValvesOK"}
						nok={"waterValvesNOK"}
						text={"waterValvesComment"}
						title={"The water valves are properly open."}
						description={"Open and close the valves if necessary."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"airLeaksOK"}
						nok={"airLeaksNOK"}
						text={"airLeaksComment"}
						title={"There are no air leaks in the pneumatic systems."}
						description={"Notify the plant maintenance department."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"materialGatesOK"}
						nok={"materialGatesNOK"}
						text={"materialGatesComment"}
						title={"The material gates have no damage."}
						description={
							"Check for visible damage and open and close gates to ensure proper operation."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"oilCompressorOK"}
						nok={"oilCompressorNOK"}
						text={"oilCompressorComment"}
						title={"The compressor oil level is adequate."}
						description={
							"Refill oil if necessary and report to the maintenance team."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"airCompressorPressureOK"}
						nok={"airCompressorPressureNOK"}
						text={"airCompressorPressureComment"}
						title={"Check air compressor pressure."}
						description={"Pressure should be between 125 - 130 psi."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"plantDispensesOK"}
						nok={"plantDispensesNOK"}
						text={"plantDispensesComment"}
						title={"The plant dispenses water properly."}
						description={"Check water dispensing from the computer system."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"bandRotatesOK"}
						nok={"bandRotatesNOK"}
						text={"bandRotatesComment"}
						title={"The belt rotates properly."}
						description={"Rotate the belt from the computer system."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"chemicalLevelOK"}
						nok={"chemicalLevelNOK"}
						text={"chemicalLevelComment"}
						title={"The chemical level is adequate to start the shift."}
						description={
							"If the level is low, report to the appropriate staff to request chemicals."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"reviewVibratorsOK"}
						nok={"reviewVibratorsNOK"}
						text={"reviewVibratorsComment"}
						title={"Check vibrators."}
						description={"Verify that the vibrators activate correctly."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"cementGateOK"}
						nok={"cementGateNOK"}
						text={"cementGateComment"}
						title={"Check cement gate."}
						description={"Verify that the cement gates are open."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"humidityProcessOK"}
						nok={"humidityProcessNOK"}
						text={"humidityProcessPercentage"}
						title={
							"Perform the humidity capture process and record humidity in the comments column."
						}
						description={
							"Perform the humidity capture process and record humidity in the comments column."
						}
						type={"percentage"}
					/>
				</Row>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			{loadingButton ? <CustomSpinner /> : <CustomForm />}
		</>
	);
};

export default ProductionWeeklyView;

const ItemChecked = ({ ok, nok, text, title, description, type }) => {
	return (
		<Col span={24}>
			<Row gutter={16} justify={"space-between"}>
				<Col span={8}>
					<Row>
						<Col span={24}>
							<Text strong>{title}</Text>
						</Col>
						<Col span={24} seco>
							<Text strong type="secondary">
								{description}
							</Text>
						</Col>
					</Row>
				</Col>
				<Col span={8}>
					<Form.Item name={text}>
						{type === "comment" && <Input.TextArea size="large" readOnly />}
						{type === "percentage" && (
							<Input size="large" suffix={"%"} readOnly />
						)}
					</Form.Item>
				</Col>
				<Col>
					<Row gutter={16}>
						<Col>
							<Form.Item name={ok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
						<Col>
							<Form.Item name={nok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
};
